<template>
  <!-- 展开时 -->
  <template v-if="!props.collapsed">
    <a-button
      v-bind="attrs"
      v-if="showBtn"
      preIcon="M-terminal-iconvip|alisvg"
      @click="handleBecomeMember"
      class="!rounded-xl"
    >
      {{ t('layout.header.becomeMember') }}
      {{ registerType || '' }}
    </a-button>
  </template>
  <!-- 收起时 -->
  <template v-else>
    <Tooltip placement="right">
      <template #title>
        <span>{{ t('layout.header.becomeMember') }} {{ registerType || '' }}</span>
      </template>
      <SvgIcon
        v-bind="attrs"
        v-if="showBtn"
        prefix="ali"
        name="M-terminal-iconvip"
        class="collapse-img self-center"
        size="32"
        @click="handleBecomeMember"
      />
    </Tooltip>
  </template>
</template>

<script setup lang="ts">
  import { usePermission } from '/@/hooks/web/usePermission';
  import { RoleEnum } from '/@/enums/roleEnum';
  //import { useGo } from '/@/hooks/web/usePage';
  import { useI18n } from '@mcex/locale';
  import { useRegisterFormStore } from '/@/store/modules/registerForm';
  import { StatusTypeEnum } from '/@/enums/accountEnum';
  import { computed } from 'vue';
  import { SvgIcon } from '/@/components/Icon';
  import { Tooltip } from 'ant-design-vue';
  import { useAttrs } from 'vue';
  import { useUserStore } from '/@/store/modules/user';
  import { useBecomeMember } from '/@/hooks/component/useBecomeMember';

  const { hasRole } = usePermission();
  //const go = useGo();
  const { t } = useI18n();
  const registerFormStore = useRegisterFormStore();
  const attrs = useAttrs();
  const props = defineProps({
    // 是否收起
    collapsed: {
      type: Boolean,
      default: false,
    },
  });

  const registerType = computed(() => {
    const registerStatus = registerFormStore.getStatus;
    if (registerStatus === StatusTypeEnum.APPLICATION_REVIEWING) {
      return `(${t('layout.header.underWay')})`;
    }
    if (registerStatus === StatusTypeEnum.REJECT) {
      return `(${t('layout.header.rejected')})`;
    }
    if (registerStatus === StatusTypeEnum.DONE) {
      return `(${t('layout.header.approved')})`;
    }
    return '';
  });

  const { handleBecomeMember } = useBecomeMember();

  const showBtn = computed(() => {
    // 登录且为普通用户
    return !!useUserStore().getToken && hasRole([RoleEnum.ORDINARY]);
  });
</script>
